// extracted by mini-css-extract-plugin
export var arrowBack = "articleNavigation-module--arrowBack--IR7B4";
export var arrowForward = "articleNavigation-module--arrowForward--USfTc";
export var backToList = "articleNavigation-module--backToList--+4ffK";